import SubstitutionIsNotValid from "../exceptions/substitution-is-not-valid";
import TeamContext from "../../common/context/team-context";

export default class FootballTeamContext extends TeamContext {
    constructor(teamId) {
        super(teamId);

        this.playersOnField = [];
        this.starters = [];
        this.participants = [];
        this.activePlayers = [];
        this.captain = null;
    }

    isPlayerOnField(player) {
        return this.playersOnField.some((p) => p.player.id === player.id);
    }

    removePlayerOnField(player) {
        const playerIndex = this.playersOnField.findIndex(
            (p) => p.player.id === player.id
        );
        this.playersOnField.splice(playerIndex, 1);
    }

    addPlayerOnField(player, position) {
        this.playersOnField.push({ player, position });
    }

    substitute(playerIn, playerOut) {
        if (
            this.isPlayerOnField(playerIn) ||
            !this.isPlayerOnField(playerOut)
        ) {
            throw new SubstitutionIsNotValid();
        }

        this.removePlayerOnField(playerOut);
        this.addPlayerOnField(playerIn);
    }

    isStarter(player) {
        return this.starters.indexOf(player.id) >= 0;
    }

    addStarter(player) {
        this.starters.push(player.id);
    }

    removeStarter(player) {
        const playerIndex = this.starters.indexOf(player.id);
        if (playerIndex >= 0) {
            this.starters.splice(playerIndex, 1);
        }
    }

    isParticipant(player) {
        return this.participants.indexOf(player.id) >= 0;
    }

    addParticipant(player) {
        this.participants.push(player.id);
    }

    addParticipants(players = []) {
        this.participants = [...this.participants, ...players.map((p) => p.id)];
    }

    removeParticipant(player) {
        const playerIndex = this.participants.indexOf(player.id);
        if (playerIndex >= 0) {
            this.participants.splice(playerIndex, 1);
        }
    }

    isActive(player) {
        return this.activePlayers.indexOf(player.id) >= 0;
    }

    addActive(player) {
        this.activePlayers.push(player.id);
    }

    removeActive(player) {
        const playerIndex = this.activePlayers.indexOf(player.id);
        if (playerIndex >= 0) {
            this.activePlayers.splice(playerIndex, 1);
        }
    }

    setCaptain(player) {
        this.captain = player.id;
    }
}
